import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=c24ab372&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=c24ab372&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c24ab372",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c24ab372')) {
      api.createRecord('c24ab372', component.options)
    } else {
      api.reload('c24ab372', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=c24ab372&scoped=true&", function () {
      api.rerender('c24ab372', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2MFfvL4SdupC1/JS/comp/PopupBox.vue"
export default component.exports